module.exports = __webpack_public_path__ + "static/media/signal_cellular_off.516c4717.svg";